import { combineReducers } from 'redux';
import { RootState } from './rootState';
import { uiReducer } from './ui/reducer';

export const rootReducer = combineReducers<RootState>({
  ui: uiReducer as any,
});
